export enum ButtonsAssets {
  GREEN_DEFAULT_BTN = 'GREEN_DEFAULT_BTN',
  GREEN_HOVER_BTN = 'GREEN_HOVER_BTN',
  GREEN_ACTIVE_BTN = 'GREEN_ACTIVE_BTN',
  GREEN_DISABLED_BTN = 'GREEN_DISABLED_BTN',

  RED_DEFAULT_BTN = 'RED_DEFAULT_BTN',
  RED_HOVER_BTN = 'RED_HOVER_BTN',
  RED_ACTIVE_BTN = 'RED_ACTIVE_BTN',
  RED_DISABLED_BTN = 'RED_DISABLED_BTN',

  YELLOW_DEFAULT_BTN = 'YELLOW_DEFAULT_BTN',
  YELLOW_HOVER_BTN = 'YELLOW_HOVER_BTN',
  YELLOW_ACTIVE_BTN = 'YELLOW_ACTIVE_BTN',
  YELLOW_DISABLED_BTN = 'YELLOW_DISABLED_BTN',
}

export enum IconAssets {
  HOME_ICON = 'HOME_ICON',
  RESET_ICON = 'RESET_ICON',
  SCALE_OUT_ICON = 'RESIZE_ICON',
  AVATAR_ICON = 'AVATAR_ICON',
  SOUND_ICON = 'SOUND_ICON',
  MUTE_SOUND_ICON = 'MUTE_SOUND_ICON',
}

export enum ImageAssets {
  BACKGROUND = 'BACKGROUND',
  LOADING_BACKGROUND = 'LOADING_BACKGROUND',
}

export enum GameAssets {
  COIN = 'COIN',
  LIFE = 'LIFE',
  FOE = 'FOE',
  PLAYER_DEFAULT = 'PLAYER_DEFAULT',
  PLAYER_HAPPY = 'PLAYER_HAPPY',
  PLAYER_DEAD = 'PLAYER_DEAD',
}
